import { AuthServer } from './../../services/auth-server.service';
import { StatusOmsService } from '@services/webFeeder/sckt-status-oms.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '@services/webFeeder/config.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { Subscription , of } from 'rxjs';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { environment } from 'src/environments/environment';
import { FinancialComplService } from '@services/webFeeder/sckt-financial.compl.service';
import { StatusConnection } from '@model/status-connection';
import * as Highcharts from 'highcharts';
import { NotificationsService } from 'angular2-notifications';
import { map } from 'rxjs';

@Component({
  selector: 'app-balance-consult',
  templateUrl: './balance-consult.component.html',
  animations: [
    trigger('valueAnimation', [
      transition('void => *', [
        style({ transform: 'translateX(0) scale(0)' }),
        animate('0.2s ease-in')
      ])
    ]),
    trigger('valueListAnimation', [
      transition('* => void', [
        animate('0.3s ease-in-out', style({ transform: 'translateX(-100%)' }))
      ]),
      transition('void => *', [
        style({
          transform: 'translateX(-100%)'
        }),
        animate('0.3s 300ms ease-in-out')
      ])
    ]),
    trigger('valueLDetailAnimation', [
      transition('* => void', [
        animate('0.3s ease-in-out', style({ transform: 'translateX(100%)' }))
      ]),
      transition('void => *', [
        style({
          transform: 'translateX(100%)'
        }),
        animate('0.3s 300ms ease-in-out')
      ])
    ])
  ]
})
export class BalanceConsultComponent implements OnInit, OnDestroy {

  private subscriptionBalance: Subscription;
  private subscriptionStatusOms: Subscription;
  private chartOpts: any;
  title = 'PATRIMÔNIO';
  statusOmsOnline = true;
  msgStatusOmsOffile = Constants.MSG_STATUS_OFFLINE_OMS;
  balanceProjOnline = '0';
  balanceD0 = '0';
  balanceD1 = '0';
  balanceD2 = '0';
  balanceD3 = '0';
  balanceProjOn = 0;
  operatingLimit = '0';
  availableBalanceStr = '0';
  operationalLimitStr = '0';
  profitLossOpenStr = '0';
  profitLossCloseStr = '0';
  profitLossTotalStr = '0';
  tradingSessionStr = '0';
  onlinePatrimonyStr = '0';
  bmfLeveragedLimitStr = '0';
  cashLeveragedLimitStr = '0';
  optionsLeveragedLimitStr = '0';
  withdrawLimitStr = '0';
  withdrawLimitUsedStr = '0';
  optionLimitStr = '0';
  bmfLimitStr = '0';
  fixedIncome = 0;
  fixedIncomeStr = '0';
  fixedIncomeLimitStr = '0,00';
  funds = 0;
  fundsStr = '0';
  fundLimitStr = '0';
  clubs = 0;
  clubsStr = '0';
  directTreasury = 0;
  directTreasuryStr = '0';
  directTreasuryLimitStr = '0,00';
  onlineCustody = 0;
  onlineCustodyStr = '0';
  earnings = 0;
  earningsStr = '0';
  positionAdjustmentStr = '0';
  guarantee = 0;
  guaranteeStr = '0';
  guaranteeMargin = 0;
  guaranteeMarginStr = '0,00';
  guaranteeTotal = 0;
  guaranteeTotalStr = '0,00';
  guaranteeConsideratePL = 0;
  guaranteeConsideratePLStr = '0,00';
  account = '';
  market = '';
  filteredHistory = [];
  loading = true;
  numberOfLines = 15;
  showValues = false;
  whiteLabel = environment.WHITELABEL;
  intervalAccount: any;
  snapBalance: any = [];
  chart: any;
  wallet: any = [];
  viewMore = false;
  viewTooltipHelp = false;
  viewTooltipOpLimit = false;
  organization = this.configService.getConfigWhitelabel();
  cardsConfig: any = this.organization && this.organization.patrimony ? this.organization.patrimony : [];
  showlayoutFullSocket = false;
  dateRequestRest: Date;
  requestGetSaldo = false;


  @ViewChild('chart') chartEl: ElementRef;
  @ViewChild('tooltipLeft') tooltipLeft: NgbTooltip;
  @ViewChild('tooltipRight') tooltipRight: NgbTooltip;
  @HostListener('mousemove') onMouseMove() {
    this._autoLogoutService.resetTime();
  }
  @HostListener('click') onClick() {
    this._autoLogoutService.resetTime();
  }

  constructor(
    public dialogRef: MatDialogRef<BalanceConsultComponent>,
    private configService: ConfigService,
    private _autoLogoutService: AutoLogoutService,
    private _financialComplService: FinancialComplService,
    private _statusOmsService: StatusOmsService,
    private _authServer: AuthServer,
    private _notificationService: NotificationsService,
  ) {
    Highcharts.setOptions({
      global: { useUTC: false } as any,
      lang: { decimalPoint: ',', thousandsSep: '.' },
    });
  }

  ngOnInit() {
    if (this.organization && this.organization.patrimony && this.organization.patrimony.customTitle) {
      this.title = this.organization.patrimony.customTitle;
    }
    this.showlayoutFullSocket = this.organization.patrimony.cardRest.showlayoutFullSocket;
    if (!this.showlayoutFullSocket) {
      this.geBalancetExternalInfo(true);
    } else {
      this.subscriptionStatusOms = this._statusOmsService.messagesStatusOms
        .subscribe((statusOms) => {
          if (statusOms === StatusConnection.ERROR) {
            this.loading = false;
            this.statusOmsOnline = false;
          } else {
            this.intervalAccount = setInterval(() => {
              this.statusOmsOnline = true;
              this.account = this.configService.getBrokerAccountSelected();
              this.market = Constants.MARKET_BOVESPA;
              if (this.account && this.market) {
                clearInterval(this.intervalAccount);
                this.getFinancialAccountInformationCompl();
              }
            }, 1000);
          }
        });
      setTimeout(() => {
        this.loading = false;
      }, 3000);
    }
  }

  ngOnDestroy() {
    if (this._financialComplService && this.account) {
      this._financialComplService.unsubscribeFinancial(
        this.account,
        'MEU SALDO'
      );
      if (this.subscriptionBalance) {
        this.subscriptionBalance.unsubscribe();
      }
    }
    if (this.subscriptionStatusOms) {
      this.subscriptionStatusOms.unsubscribe();
    }
    if (this.intervalAccount) {
      clearInterval(this.intervalAccount);
    }
  }

  retry() {
    this.requestGetSaldo = false;
    this.geBalancetExternalInfo(true);
  }

  geBalancetExternalInfo(getLimite: boolean = true) {
    this.loading = true;
    this.dateRequestRest = new Date();
    this._authServer.iNegotiation.geBalancetExternalInfo(getLimite)
      .subscribe(res => {
        if (res && !res.error && res.data) {
          if (!this.requestGetSaldo) {
            this.account = res.data.codigoContaSinacor;
            this.operatingLimit = res.data.limites[this.organization.patrimony.cardRest.propNames.operatingLimit] >= 0
              ? AppUtils.convertNumberToCurrency(Number(res.data.limites[this.organization.patrimony.cardRest.propNames.operatingLimit])) : 'Valor Indisponível';
          } else {
            this.availableBalanceStr = res.data[this.organization.patrimony.cardRest.propNames.availableBalanceStr] >= 0
              ? AppUtils.convertNumberToCurrency(Number(res.data[this.organization.patrimony.cardRest.propNames.availableBalanceStr])) : 'Valor Indisponível';
            this.balanceD1 = res.data[this.organization.patrimony.cardRest.propNames.balanceD1] >= 0
              ? AppUtils.convertNumberToCurrency(Number(res.data[this.organization.patrimony.cardRest.propNames.balanceD1])) : 'Valor Indisponível';
            this.balanceD2 = res.data[this.organization.patrimony.cardRest.propNames.balanceD2] >= 0
              ? AppUtils.convertNumberToCurrency(Number(res.data[this.organization.patrimony.cardRest.propNames.balanceD2])) : 'Valor Indisponível';
          }
          if (!this.requestGetSaldo) {
            this.requestGetSaldo = true;
            this.geBalancetExternalInfo(false);
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        } else {
          this.setErrorRequestRest();
        }
      }, () => {
        this.setErrorRequestRest();
      });
  }

  setErrorRequestRest() {
    this.availableBalanceStr = 'Valor Indisponível';
    this.operatingLimit = 'Valor Indisponível';
    this.balanceD1 = 'Valor Indisponível';
    this.balanceD2 = 'Valor Indisponível';
    this._notificationService.error('', Constants.MSG_LOGIN_MSG013);
    this.loading = false;
  }

  getFinancialAccountInformationCompl() {
    this._financialComplService.subscribeFinancial(this.account, 'MEU SALDO');
    this.subscribeFinancialService();
  }

  subscribeFinancialService() {
    this.subscriptionBalance = this._financialComplService.messages.subscribe(
      (data) => {
        if (data) {
          if (this.snapBalance.length > 0) {
            let indexTemp;
            let posTemp;
            data.forEach((element) => {
              this.snapBalance.find((x, index) => {
                if (x.quote.toUpperCase() === element.quote.toUpperCase()) {
                  indexTemp = index;
                  posTemp = element;
                }
              });
              if (posTemp && indexTemp >= 0) {
                this.snapBalance[indexTemp] = posTemp;
                posTemp = null;
                indexTemp = null;
              } else {
                this.snapBalance.push(element);
              }
            });
          } else {
            this.snapBalance = data;
          }
          this.updateBalance();
          if (!this.chartOpts && this.organization.patrimony && this.organization.patrimony.position) {
            this.buildChart();
          }
        }
      }
    );
  }

  updateBalance() {
    if (
      this.snapBalance &&
      this.snapBalance.financialInformationBean &&
      this.snapBalance.financialInformationBean.length > 0 &&
      this.account
    ) {
      for (
        let i = 0;
        i < this.snapBalance.financialInformationBean.length;
        i++
      ) {
        if (
          this.snapBalance.financialInformationBean[
            i
          ].account.value.toLowerCase() === this.account.toLowerCase()
        ) {
          this.snapBalance.financialInformationBean.map((elem:any) => {

            if (elem.uniqueLimit && elem.uniqueLimit.value) {
              this.operationalLimitStr = AppUtils.convertNumberToCurrency(Number(elem.uniqueLimit.value));
            }

            if (elem.openProfitLoss && elem.openProfitLoss.value) {
              this.profitLossOpenStr = AppUtils.convertNumberToCurrency(Number(elem.openProfitLoss.value));
            }

            if (elem.closedProfitLoss && elem.closedProfitLoss.value) {
              this.profitLossCloseStr = AppUtils.convertNumberToCurrency(Number(elem.closedProfitLoss.value));
            }

            if (elem.profitTotalLoss && elem.profitTotalLoss.value) {
              this.profitLossTotalStr = AppUtils.convertNumberToCurrency(Number(elem.profitTotalLoss.value));
            }

            if (elem.availableBalance && elem.availableBalance.value) {
              this.availableBalanceStr = AppUtils.convertNumberToCurrency(Number(elem.availableBalance.value));
            }

            if (elem.bmfTradingAdjust && elem.bmfTradingAdjust.value) {
              this.tradingSessionStr = AppUtils.convertNumberToCurrency(Number(elem.bmfTradingAdjust.value));
            }

            if (elem.totalEquity && elem.totalEquity.value) {
              this.onlinePatrimonyStr = AppUtils.convertNumberToCurrency(Number(elem.totalEquity.value));
            }

            if (elem.fixedIncome && elem.fixedIncome.value) {
              this.fixedIncomeStr = AppUtils.convertNumberToCurrency(Number(elem.fixedIncome.value));
              this.fixedIncome = Number(elem.fixedIncome.value);
            }

            if (elem.funds && elem.funds.value) {
              this.fundsStr = AppUtils.convertNumberToCurrency(Number(elem.funds.value));
              this.funds = Number(elem.funds.value);
            }

            if (elem.clubs && elem.clubs.value) {
              this.clubsStr = AppUtils.convertNumberToCurrency(Number(elem.clubs.value));
              this.clubs = Number(elem.clubs.value);
            }

            if (elem.treasuryDirect && elem.treasuryDirect.value) {
              this.directTreasuryStr = AppUtils.convertNumberToCurrency(Number(elem.treasuryDirect.value));
              this.directTreasury = Number(elem.treasuryDirect.value);
            }

            if (
              elem.totalOnlineBmfPortfolioValue && elem.totalOnlineBmfPortfolioValue.value &&
              elem.totalOnlineOptionsPortfolioValue && elem.totalOnlineOptionsPortfolioValue.value &&
              elem.totalOnlineStockPortfolioValue && elem.totalOnlineStockPortfolioValue.value
            ) {
              this.onlineCustody = Number(elem.totalOnlineBmfPortfolioValue.value) + Number(elem.totalOnlineOptionsPortfolioValue.value) + Number(elem.totalOnlineStockPortfolioValue.value);
              this.onlineCustodyStr = AppUtils.convertNumberToCurrency(this.onlineCustody);
            }

            if (elem.xbspWarrantyTotal && elem.xbspWarrantyTotal.value &&
              elem.xbmfWarrantyTotal && elem.xbmfWarrantyTotal.value
            ) {
              this.guarantee = Number(elem.xbspWarrantyTotal.value) + Number(elem.xbmfWarrantyTotal.value);
              this.guaranteeStr = AppUtils.convertNumberToCurrency(this.guarantee);
            }

            if (elem.margemBMFlivre && elem.margemBMFlivre.value) {
              this.guaranteeMargin = Number(elem.margemBMFlivre.value);
              this.guaranteeMarginStr = AppUtils.convertNumberToCurrency(this.guaranteeMargin);
            }

            if (elem.margemGarantias && elem.margemGarantias.value) {
              this.guaranteeTotal = Number(elem.margemGarantias.value);
              this.guaranteeTotalStr = AppUtils.convertNumberToCurrency(this.guaranteeTotal);
            }

            if (elem.consideradoPl && elem.consideradoPl.value) {
              this.guaranteeConsideratePL = Number(elem.consideradoPl.value);
              this.guaranteeConsideratePLStr = AppUtils.convertNumberToCurrency(this.guaranteeConsideratePL);
            }

            if (elem.dividends && elem.dividends.value) {
              this.earnings = Number(elem.dividends.value);
              this.earningsStr = AppUtils.convertNumberToCurrency(this.earnings);
            }

            if (elem.bmfPositionAdjust && elem.bmfPositionAdjust.value) {
              this.positionAdjustmentStr = AppUtils.convertNumberToCurrency(Number(elem.bmfPositionAdjust.value));
            }

            if (elem.bmfLeveragedLimit && elem.bmfLeveragedLimit.value) {
              this.bmfLeveragedLimitStr = AppUtils.convertNumberToCurrency(Number(elem.bmfLeveragedLimit.value));
            }

            if (elem.bmfLeveragedLimit && elem.bmfLeveragedLimit.value) {
              this.fundLimitStr = AppUtils.convertNumberToCurrency(Number(elem.bmfLeveragedLimit.value));
            }

            if (elem.cashLeveragedLimit && elem.cashLeveragedLimit.value) {
              this.cashLeveragedLimitStr = AppUtils.convertNumberToCurrency(Number(elem.cashLeveragedLimit.value));
            }

            if (elem.optionsLeveragedLimit && elem.optionsLeveragedLimit.value) {
              this.optionsLeveragedLimitStr = AppUtils.convertNumberToCurrency(Number(elem.optionsLeveragedLimit.value));
            }

            if (elem.withdrawLimit && elem.withdrawLimit.value) {
              this.withdrawLimitStr = AppUtils.convertNumberToCurrency(Number(elem.withdrawLimit.value));
            }

            if (elem.withdrawLimitUsed && elem.withdrawLimitUsed.value) {
              this.withdrawLimitUsedStr = AppUtils.convertNumberToCurrency(Number(elem.withdrawLimitUsed.value));
            }

            if (elem.optionLimit && elem.optionLimit.value) {
              this.optionLimitStr = AppUtils.convertNumberToCurrency(Number(elem.optionLimit.value));
            }

            if (elem.bmfLimit && elem.bmfLimit.value) {
              this.bmfLimitStr = AppUtils.convertNumberToCurrency(Number(elem.bmfLimit.value));
            }

            if (elem.tediLimit && elem.tediLimit.value) {
              this.directTreasuryLimitStr = AppUtils.convertNumberToCurrency(Number(elem.tediLimit.value));
            }

            if (elem.refiLimit && elem.refiLimit.value) {
              this.fixedIncomeLimitStr = AppUtils.convertNumberToCurrency(Number(elem.refiLimit.value));
            }

            if (elem.balanceProjOnline && elem.balanceProjOnline.value) {
              this.balanceProjOnline = AppUtils.convertNumberToCurrency(Number(elem.balanceProjOnline.value));
            }

            if (elem.balanceProjOnline && elem.balanceProjOnline.value) {
              this.balanceProjOnline = AppUtils.convertNumberToCurrency(Number(elem.balanceProjOnline.value));
            }


            if (elem.balanceD0 && elem.balanceD0.value) {
              this.balanceD0 = AppUtils.convertNumberToCurrency(Number(elem.balanceD0.value));
            }

            if (elem.balanceD1 && elem.balanceD1.value) {
              this.balanceD1 = AppUtils.convertNumberToCurrency(Number(elem.balanceD1.value));
            }

            if (elem.balanceD2 && elem.balanceD2.value) {
              this.balanceD2 = AppUtils.convertNumberToCurrency(Number(elem.balanceD2.value));
            }

            if (elem.balanceD3 && elem.balanceD3.value) {
              this.balanceD3 = AppUtils.convertNumberToCurrency(Number(elem.balanceD3.value));
            }

            if (elem.balanceProjOnline && elem.balanceProjOnline.value) {
              this.balanceProjOn = Number(elem.balanceProjOnline.value);
            }
          });
          this.loading = false;
        }
      }
    }
  }

  close() {
    this.dialogRef.close();
  }

  showHideValues() {
    this.showValues = !this.showValues;
    if (this.showValues) {
      const elements: any = document.getElementsByClassName('graphic-value');
      for (let item of elements) {
        item.classList.add('hidden-graphic');
      }
    } else {
      const elements: any = document.getElementsByClassName('graphic-value');
      for (let item of elements) {
        item.classList.remove('hidden-graphic');
      }
    }
  }

  private buildChart() {
    this.chartOpts = {
      chart: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        events: {
          redraw: function (e) {
            e.preventDefault();
          },
        },
        width: window.innerWidth <= 1600 ? 250 : 350,
        height: window.innerHeight <= 768 ? 250 : '',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        renderTo: 'chart',
        type: 'pie',
      },
      plotOptions: {
        pie: {
          borderWidth: 0,
          borderColor: null,
          allowPointSelect: true,
          plotBorderWidth: 0,
          color: 'transparent',
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          innerSize: '50%',
          plotShadow: false,
          point: {
            events: {
              legendItemClick: function (e) {
                e.preventDefault();
              },
            },
          },
          showInLegend: false,
          type: 'pie',
        },
      },
      series: [
        {
          colorByPoint: true,
          data: this.setValuesToChart(),
          enableMouseTracking: false,
          events: {
            legendItemClick: false,
          },
          name: 'BalanceConsultChart',
        },
      ],
      title: { text: null, subtitle: '' },
    };
    setTimeout(() => {
      if (this.chartEl) {
        this.chart = Highcharts.chart(
          this.chartEl.nativeElement,
          this.chartOpts
        );
        Highcharts.charts[Highcharts.charts.length - 1].update({});
      }
    }, 100);
  }

  private setValuesToChart() {
    const theme =
      window.sessionStorage.getItem(Constants.LAYOUT_THEME_DARK) === 'true'
        ? 'dark'
        : 'light';
    const bodyStyles = window.getComputedStyle(document.body);
    const colorCustody = bodyStyles.getPropertyValue(
      `--color-${theme}-custody`
    );
    const colorEarnings = bodyStyles.getPropertyValue(
      `--color-${theme}-earnings`
    );
    const colorGuarantee = bodyStyles.getPropertyValue(
      `--color-${theme}-guarantee`
    );
    const colorClubs = bodyStyles.getPropertyValue(`--color-${theme}-clubs`);
    const colorFixedIncome = bodyStyles.getPropertyValue(
      `--color-${theme}-fixed-income`
    );
    const colorFunds = bodyStyles.getPropertyValue(`--color-${theme}-funds`);
    const colorTreasure = bodyStyles.getPropertyValue(
      `--color-${theme}-treasure`
    );
    const colorStocks = bodyStyles.getPropertyValue(`--color-${theme}-stocks`);
    const colorForesight = bodyStyles.getPropertyValue(
      `--color-${theme}-foresight`
    );
    const colorDesignedOnline = bodyStyles.getPropertyValue(
      `--color-${theme}-designed-online`
    );

    if (this.onlineCustody > 0 && this.showPositionDetail('onlineCustodyStr')) {
      this.wallet.push({
        name: 'Custódia online ',
        y: this.onlineCustody,
        color: colorCustody,
      });
    }
    if (this.earnings > 0 && this.showPositionDetail('earningsStr')) {
      this.wallet.push({
        name: 'Proventos',
        y: this.earnings,
        color: colorEarnings,
      });
    }
    if (this.guarantee > 0 && this.showPositionDetail('guaranteeStr')) {
      this.wallet.push({
        name: 'Garantia',
        y: this.guarantee,
        color: colorGuarantee,
      });
    }
    if (this.directTreasury > 0 && this.showPositionDetail('directTreasuryStr')) {
      this.wallet.push({
        name: 'Tesouro Direto',
        y: this.directTreasury,
        color: colorTreasure,
      });
    }
    if (this.fixedIncome > 0 && this.showPositionDetail('fixedIncomeStr')) {
      this.wallet.push({
        name: 'Renda Fixa',
        y: this.fixedIncome,
        color: colorFixedIncome,
      });
    }
    if (this.funds > 0 && this.showPositionDetail('fundsStr')) {
      this.wallet.push({
        name: 'Fundos',
        y: this.funds,
        color: colorFunds,
      });
    }
    if (this.clubs > 0 && this.showPositionDetail('clubsStr')) {
      this.wallet.push({
        name: 'Clubes',
        y: this.clubs,
        color: colorClubs,
      });
    }
    if (this.balanceProjOn > 0 && this.showPositionDetail('balanceProjOnline')) {
      this.wallet.push({
        name: 'balanceProjOn',
        y: this.balanceProjOn,
        color: colorDesignedOnline,
      });
    }

    this.wallet =
      this.wallet.filter((item) => item.y > 0).length > 0 ? this.wallet : [];

    return this.wallet;
  }

  showPositionDetail(detail) {
    if (this.organization && this.organization.patrimony && this.organization.patrimony.positionDetail) {
      return this.organization.patrimony.positionDetail[detail];
    }
  }
}
